import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.page.html',
  styleUrls: ['./aboutus.page.scss'],
})
export class AboutusPage implements OnInit {
  public env = environment;
  language: string;
  selectedLanguage: any;
  constructor(
    private translate: TranslateService,
    private router: Router,
    public location: Location,
    public http: HttpClient
  ) { }

  ionViewWillEnter() {
    this.language = localStorage.getItem("language");
    if (this.language === 'hn') {
      this.getTranslateHn();
    }
    else if (this.language === 'en') {
      this.getTranslateEng();
    } else if (this.language === 'kn') {
      this.getTranslateEng();
    }
  }
  ngOnInit() {
  }
  public backClick(): void {
    this.location.back();
  }

  content = '';
  async getTranslateEng() {
    await this.http.get<any>(`${environment.s3AssetsUrl}/site/assets/about+us_engjson.json?${(new Date().getTime())}`)
      // .map(data => data.json())
      .subscribe(data => {
        this.selectedLanguage = data;
        // for(const [key, value])
        Object.entries(data).forEach(([k, v]) => {
          console.log(k,v)
          if (k != 'Title') {
            this.content = v.toString();
          }
        })
        console.log(Object.keys(data));
        // this.content = data['​content'];
        console.log(this.selectedLanguage);
      })
  }

  async getTranslateHn() {
    await this.http.get<any>(`${environment.s3AssetsUrl}/site/assets/about+us_engjson.json?${(new Date().getTime())}`)
      // .map(data => data.json())
      .subscribe(data => {
        this.selectedLanguage = data;
        //console.log(data);
      })
  }

}
